<template>
    <div class="container">
        <div class="row mt-5">
            <div class="col text-center">
                <h2>Machining</h2>
                <hr class="small-hr-line">
            </div>
        </div>
        <div class="row">
            <LightGallery
                    :images="images"
                    :index="index"
                    :disable-scroll="true"
                    @close="index = null"
            />

            <div
                    v-for="(image, imageIndex) in images"
                    :key="image.url"
                    @click="index = imageIndex"
            >
                <div class="gallery-item">
                    <img class="gallery-item-img" :src="image.url">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "architectural_component",
        beforeMount() {
        },
        data() {
            return {
                images: [
                    {title: '', url: '../static/machining/Aluminum-Pegs-1-Full.jpg'},
                    {title: '', url: '../static/machining/Aluminum-Pegs-2-Full.jpg'},
                    {title: '', url: '../static/machining/Aluminum-Pegs-3-Full.jpg'},
                    {title: '', url: '../static/machining/mach-gally.jpg'},
                    {title: '', url: '../static/machining/mach-handle.jpg'},
                    {title: '', url: '../static/machining/mach-kick-1.jpg'},
                    {title: '', url: '../static/machining/mach-plastic-pad.jpg'},
                    {title: '', url: '../static/machining/mach-plastic-vblock.jpg'},
                    {title: '', url: '../static/machining/mach-power-1.jpg'},
                    {title: '', url: '../static/machining/mach-power-2.jpg'},
                    {title: '', url: '../static/machining/mach-power-3.jpg'},
                    {title: '', url: '../static/machining/mach-railbracket-1.jpg'},
                    {title: '', url: '../static/machining/mach-railbracket-2.jpg'},
                    {title: '', url: '../static/machining/Steel-Clevis-Mounts-Full.jpg'},
                ],
                index: null
            }
        }
    }
</script>

<style scoped>

</style>